export const availableLanguages = [
  { value: "es", name: "ES" },
  { value: "en", name: "EN" },
];

export const defaultLanguage = "es";
